'use client'

import { forwardRef } from 'react'
import Popover, { popoverPositionStyle } from '@components/common/Popover'
import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { theme } from '@ui/style'
import UIDivider from '@components/ui/UIDivider'

interface AIPopoverProps {
	content?: string
	open: boolean
	onClose: () => void
}

const AIPopover = forwardRef<HTMLDivElement, AIPopoverProps>(({ content, open, onClose }, ref) => {
	return (
		<Popover
			title="AI 본문 요약"
			onClose={onClose}
			open={open}
			ref={ref}
			sx={{
				[theme.breakpoints.down('md')]: {
					...popoverPositionStyle['bottom-start'],
				},
			}}
		>
			<UIFlex
				sx={{
					'&>*:not(:first-child)': {
						marginTop: pxToRem(16),
					},
				}}
			>
				<UIDivider orientation="horizontal" sx={{ background: color.colGray2 }} />
				<UIText
					fontSize={pxToRem(15)}
					lineHeight={pxToRem(22)}
					fontWeight={500}
					sx={{
						whiteSpace: 'pre-wrap',
					}}
				>
					{content}
				</UIText>
				<UIText
					fontSize={pxToRem(12)}
					lineHeight={pxToRem(18)}
					fontWeight={500}
					color={color.colGray4}
				>
					본문 요약은 Google의 Gemini를 통해 제공하고 있으며, 전체 내용을 이해하기 위해선
					본문 내용과 함께 보는 것을 권장합니다.
				</UIText>
			</UIFlex>
		</Popover>
	)
})

export default AIPopover
